import { RoleHeaderModel } from "@/Administration/Models/Role/RoleHeaderModel";
import { Icon } from "@/Common/Components/IconControls/IconControls";
import { FormMode } from "@/Common/Models/UI/Enums";

import styles from "@/Administration/Components/Roles/Field/RoleListComponent.module.scss";

interface RoleListComponentProps {
    readonly onRemoveRoleClick: (id: string) => void;
    readonly roles: RoleHeaderModel[];
    readonly formMode: FormMode
    readonly dataCy?: string;
}

function RoleListComponent(props: RoleListComponentProps): JSX.Element {
    return (
        <div className={styles.roleList} data-cy={`${props.dataCy}-role-list`}>
            {props.formMode == FormMode.Edit && (props.roles
                ?.map((role: RoleHeaderModel) => (
                    <div key={`role_${role.Id}`} data-cy={`${props.dataCy}-role-item-${role.Id}`}>
                        <span className={styles.role_item}>{role.Name}</span>
                        <button
                            onClick={() => props.onRemoveRoleClick(role.Id)}
                            className={styles.deleteIconContainer}
                            data-cy={`${props.dataCy}-remove-role-${role.Id}`}
                        >
                            <Icon
                                iconHeight="16px"
                                iconWidth="16px"
                                type="delete-icon"
                            />
                        </button>
                    </div>
                )))}
            {props.formMode == FormMode.View && (
                <div className={styles.roleLine}>
                    {props.roles.map((role: RoleHeaderModel, idx: number) => (
                        <span key={`role_${role.Id}`} data-cy={`${props.dataCy}-role-item-${role.Id}`}>{`${role.Name}${idx != props.roles.length - 1 ? ", " : ""}`}</span>
                    ))}
                </div>
            )}
        </div>
    );
}

export { RoleListComponent };
